import React from 'react'
import "../assets/css/notfound.css"
import naruto from "../assets/images/naruto.gif"

function Notfund() {
  return (
    <div className='not-found'>Notfound
    <img src={naruto} alt="dino" /></div>
  )
}

export default Notfund;